// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"306":"677a5e81","321":"75df657f","605":"62acf166","628":"47237459","916":"7ce2b437","990":"26a0a5c3"}[chunkId] + ".css";
};